import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'


/***
 *
 * 获取商品表列表 get
 * @param orderId 订单ID
 * @return request
 * */
export function getIntegralsByOrderId(orderId) {
  return request({
    url: `${baseURL.businessApi}/integrals/byOrderId/${orderId}`,
    method: 'get'
  })
}

/***
 *
 * 新增积分
 * @param data 发送积分数据
 * @return request
 * */
export function addIntegrals(data) {
  return request({
    url: `${baseURL.businessApi}/integrals`,
    method: 'post',
    data
  })
}


/***
 *
 * 获取用户积分列表
 * @return request
 * @param query
 * @param userId
 * */
export function getIntegralsByUserId(query, userId) {
  return request({
    url: `${baseURL.businessApi}/integrals/byUserId/${userId}`,
    method: 'get',
    params: query
  })
}

/**
 * 修改积分记录
 * @param id
 * @param data
 * @returns {AxiosPromise}
 */
export function postModifyIntegralsById(id, data) {
  return request({
    url: `${baseURL.businessApi}/integrals/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 删除积分记录
 * @param id
 * @returns {AxiosPromise}
 */
export function deleteIntegralsById(id) {
  return request({
    url: `${baseURL.businessApi}/integrals/${id}`,
    method: 'delete'
  })
}
